export default __webpack_public_path__ + "static/media/menu22.f61e61f5.svg";